import { Checkbox, Input, message, Modal } from "antd";
import React, { useEffect } from "react";
import { FlexibleSelectHeaderProps } from "./type";
import { observer } from "mobx-react-lite";
import AutoLoadingButton from "@/components/AutoLoadingButton";
import { useLinkedProductSearchFieldsStore } from "../LinkedProductSearchFieldsStore";
import { useGlobalStore } from "@/store/hooks";
import moment from "moment";
import { difference } from "lodash";

const FlexibleSelectHeader: React.FC<FlexibleSelectHeaderProps> = function (props) {
    const {
        multiple,
        isIndeterminate,
        isSelectAll,
        onSelectAllChange,
        onPreventComputed,
        onSearch,
        searchText,
        data,
        multipleValue,
    } = props;

    const globalStore = useGlobalStore();
    const store = useLinkedProductSearchFieldsStore();
    const shop = globalStore.shopSettingMapping.get(store.shopId);

    useEffect(() => {
        if (!shop && store.shopId) {
            globalStore.getShopSetting([store.shopId]);
        }
    }, [store.shopId]);

    function handleInputChange(e) {
        const value = e.target.value;

        onSearch?.(value);

        onPreventComputed();
    }

    function handleSelectAllChange(e) {
        const checked = e.target.checked;

        /**
         * 如果是选中的状态，需要根据下拉面板的值进行最终的选中判断
         */

        let realCheck = checked;

        if (checked) {
            const currentDataSourceValues = data.map(({ value }) => value);

            realCheck = difference(currentDataSourceValues, multipleValue || []).length !== 0;
        }

        onSelectAllChange(realCheck);
    }

    return (
        <div className="header p5">
            <div className="left">
                {multiple ? (
                    <span className="text-light fs13">
                        <Checkbox
                            checked={isSelectAll}
                            indeterminate={isIndeterminate}
                            onChange={handleSelectAllChange}
                        >
                            全选
                        </Checkbox>

                        <Input
                            style={{ width: "70%" }}
                            onChange={handleInputChange}
                            value={searchText}
                            placeholder="请输入关键词搜索"
                        />
                    </span>
                ) : null}
            </div>

            <div className="right">
                {shop ? (
                    <span className="">
                        <AutoLoadingButton
                            size="small"
                            type="default"
                            onClick={async () => {
                                await store.updateLatestProducts();

                                message.success("更新商品成功");

                                shop.lastOrderItemSkuInfoUpdateTime = moment().format("YYYY-MM-DD HH:mm:ss");
                            }}
                        >
                            重新统计
                        </AutoLoadingButton>

                        {shop.lastOrderItemSkuInfoUpdateTime ? (
                            <span className="last-update-time ml5">
                                统计时间：{moment(shop.lastOrderItemSkuInfoUpdateTime).format("MM-DD HH:mm")}
                            </span>
                        ) : null}
                    </span>
                ) : (
                    <AutoLoadingButton size="small" type="default" onClick={store.updateLatestProductsByShopIds}>
                        重新统计
                    </AutoLoadingButton>
                )}
            </div>
        </div>
    );
};

export default observer(FlexibleSelectHeader);
